import React from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { Spin, Tabs } from 'antd';
// Constants
import { EVENTS, TICKETING_SETTINGS } from 'constants/routes';
import { EventsTab } from './constants';
// Hooks
import { useTicketingLaunched } from 'hooks';
// Components
import AllOrders from './components/AllOrders/AllOrders';
import EventsTable from './components/EventsTable/EventsTable';
import TicketingOverview from './components/TicketingOverview/TicketingOverview';
// Styles
import styles from './Events.module.scss';

const { TabPane } = Tabs;

const Events = (): JSX.Element => {
  const history = useHistory();
  const { eventsTab } = useParams<{ eventsTab?: string }>();
  const { launched, loading } = useTicketingLaunched();
  const activeTab =
    eventsTab === EventsTab.Orders ? EventsTab.Orders : EventsTab.All;

  // Until launch only the settings page, where the launch switch is, can be opened
  if (!launched) {
    return loading ? <Spin /> : <Redirect to={TICKETING_SETTINGS} />;
  }

  return (
    <div className={styles.root}>
      <Tabs
        activeKey={activeTab}
        onChange={(tab) => history.push(`${EVENTS}/${tab}`)}
        destroyInactiveTabPane
      >
        <TabPane tab="All events" key={EventsTab.All}>
          <TicketingOverview />
          <EventsTable />
        </TabPane>
        <TabPane tab="Orders" key={EventsTab.Orders}>
          <AllOrders />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Events;
